import { useState, useCallback } from 'react';

function useConfirmModal() {
    const [modalState, setModalState] = useState({
        show: false,
        action: null,
        message: null,
        onConfirm: null,
    });

    const showConfirmModal = useCallback((action, onConfirm, message = null) => {
        setModalState({ show: true, action, message, onConfirm });
    }, []);

    const closeConfirmModal = useCallback(() => {
        setModalState({ show: false, action: null, message: null, onConfirm: null });
    }, []);

    const handleConfirmModal = useCallback(() => {
        if (modalState.onConfirm) modalState.onConfirm();
        closeConfirmModal();
    }, [modalState.onConfirm, closeConfirmModal]);

    return {
        setConfirmModal: {
            show: modalState.show,
            action: modalState.action,
            message: modalState.message,
            onClose: closeConfirmModal,
            onConfirm: handleConfirmModal,
        },
        showConfirmModal: showConfirmModal,
    };
}
export default useConfirmModal;